import React from "react";
import {useStores} from "../../../../../Hooks";

export const SettingsHeader = ({title, Icon}) => {
    const {workspaceManagement} = useStores();
        return (
            <section className="flex-grow bg-inputfield-normal rounded-menu p-2 font-sans">
                <div className="flex flex-row items-center gap-3">
                    <Icon />
                    <div className="flex flex-col items-center justify-center font-bold text-main-normal text-base">
                        {title}
                    </div>
                </div>
            </section>
        )
};